<template>
  <div class="account" ref="account">
    <keep-alive>
      <router-view>
        <template slot="my-bookings-header-grid">
          <slot name="my-bookings-header-grid"></slot>
        </template>
        <template slot="my-bookings-grid">
          <slot name="my-bookings-grid"></slot>
        </template>
        <template slot="booking-overview-grid">
          <slot name="booking-overview-grid"></slot>
        </template>
        <template slot="my-details-grid">
          <slot name="my-details-grid"></slot>
        </template>
        <template slot="passenger-details-grid">
          <slot name="passenger-details-grid"></slot>
        </template>
      </router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  props: ['data'],

  created() {
    this.$store.commit('account/setData', this.data);
  }
}
</script>